import { inject } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, QueryRoute, RouteStore } from 'bernie-core';
import { ErrorBoundary, Layer } from 'bernie-view';

import { ExitIntentModel } from 'models/common/common-types';

import { ExitIntentOverlay } from 'components/search/exit-intent-overlay';

const MOUSE_LEAVE_EVENT = 'mouseleave';
const EXIT_INTENT_ID = 'exit-intent';
const HIDE_EXIT_INTENT = 'hide-exit-intent';

export interface ExitIntentProps {
  routeStore?: RouteStore;
  exitIntent?: ExitIntentModel;
  analytics?: AnalyticsStore;
  showOnce?: boolean;
}

@inject('routeStore', 'analytics')
export class ExitIntent extends React.Component<ExitIntentProps> {
  constructor(props) {
    super(props);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.triggerExitIntent = this.triggerExitIntent.bind(this);
  }

  private handleDismiss() {
    this.props.routeStore.goBack();
  }

  private removeMouseLeaveListener() {
    document.body.removeEventListener(MOUSE_LEAVE_EVENT, this.triggerExitIntent);
  }

  private triggerExitIntent() {
    const { routeStore, analytics, showOnce } = this.props;
    if (showOnce) {
      if (routeStore.search.includes('pwaOverlay') || localStorage.getItem(HIDE_EXIT_INTENT)) {
        return null;
      }
    } else {
      if (routeStore.search.includes('pwaOverlay')) {
        return null;
      }
    }
    localStorage.setItem(HIDE_EXIT_INTENT, 'true');
    routeStore.updateSearch({ pwaDialog: EXIT_INTENT_ID });
    if (analytics && typeof analytics.trackEvent === 'function') {
      analytics.trackEvent(`.ExitIntent.Triggered`, `Exit Intent pop up was triggered`, analytics.omnitureData);
    }
    this.removeMouseLeaveListener();
  }

  public componentDidMount() {
    document.body.addEventListener(MOUSE_LEAVE_EVENT, this.triggerExitIntent);
  }

  public componentWillUnmount() {
    this.removeMouseLeaveListener();
  }

  public render(): JSX.Element {
    const { exitIntent } = this.props;

    return (
      <ErrorBoundary label="exit.intent.error.boundary">
        <QueryRoute query={{ pwaDialog: EXIT_INTENT_ID }}>
          <Layer id={EXIT_INTENT_ID} onDismiss={this.handleDismiss}>
            <ExitIntentOverlay exitIntent={exitIntent} handleDismiss={this.handleDismiss} />
          </Layer>
        </QueryRoute>
      </ErrorBoundary>
    );
  }
}
